import { z } from "zod";
import { TObjectBase } from "../base";

export type IRawPropertyMember = z.infer<typeof TRawPropertyMember>;
export const TRawPropertyMember = z.object({
  admin: z.boolean().default(false),
  operationManager: z.boolean().optional(),
  roles: z.array(z.number()).default([]),
  roleTitle: z.string().optional(),
  units: z.array(z.string()).optional(),
  contractorGroups: z.array(z.string()).optional(),
})
.extend(TObjectBase.shape);
